export default "__VITE_ASSET__DnEr0h5n__"